import styles from "./LoadingSpinner.module.css";

interface LoadingSpinnerProps {
  label: string;
}

export const LoadingSpinner = ({ label }: LoadingSpinnerProps) => {
  return (
    <div className={styles.container} role="status" aria-live="polite" aria-busy="true">
      <div className={styles.spinner} aria-hidden="true" />
      <span className={styles.label}>{label}</span>
    </div>
  );
};
